import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import css from './MetricField.css';
import { getCohortFieldAndPeriod } from '../../../metricsUtils';
import { formatSymbol, getFormattingFunction } from '../metricDisplayUtils';
import Tooltip from '../../../../components/molecules/Tooltip';
import { GalleryContext } from '../../../consts';

const MetricField = ({ value, label, shortLabel, data, cohort = false }) => {
    const { fieldsMetadata } = useContext(GalleryContext);

    const metricValue = data[value];

    let metricBaseName = value;

    if (cohort) {
        [metricBaseName] = getCohortFieldAndPeriod(value);
    }

    const { display_format: displayFormat = {} } = fieldsMetadata[metricBaseName] || {};

    const [formattingFunction, symbol] = getFormattingFunction(displayFormat);
    const formattedValue = formatSymbol(formattingFunction(metricValue, false), symbol);
    const formattedFullValue = formatSymbol(formattingFunction(metricValue, true), symbol);

    return (
        <Tooltip key={value} title={`${label}: ${formattedFullValue}`}>
            <div className={css.field}>
                <div className={css.label}>{shortLabel || label}:</div>
                <div className={css.value}>{formattedValue}</div>
            </div>
        </Tooltip>
    );
};

MetricField.propTypes = {
    value: PropTypes.string,
    label: PropTypes.string,
    shortLabel: PropTypes.string,
    data: PropTypes.object,
    cohort: PropTypes.bool,
};

export default MetricField;
